import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { PROFFIT_SEARCH_LANDING_PAGE_KEY_VISUAL_BG_IMAGE_URL } from '../../../../../define/consts/assets';
import { propBool, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import SlideSearchTitleIcon from '../../../../Icon/Svg/SlideSearchTitleIcon';
import ProffitSearchLandingPageCtaButton from '../../Parts/ProffitSearchLandingPageCtaButton';
const ProffitSearchLandingPageFooter = (props) => {
    const { isEndTrial, plan, showFormModal } = props;
    const style = useMemo(() => ({
        backgroundImage: `url("${PROFFIT_SEARCH_LANDING_PAGE_KEY_VISUAL_BG_IMAGE_URL}")`,
    }), []);
    return (_jsx("section", Object.assign({ className: 'proffit_search_landing_page_footer', style: style }, { children: _jsxs("div", Object.assign({ className: 'footer_inner' }, { children: [_jsx(SlideSearchTitleIcon, { className: 'footer_logo white' }), _jsxs("h5", Object.assign({ className: 'footer_title' }, { children: ["\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u306E", _jsx("br", { className: 'md-is-show' }), "\u30B9\u30E9\u30A4\u30C9\u4F5C\u6210\u6642\u9593\u30921/5\u306B\u3002"] })), _jsx("div", Object.assign({ className: 'footer_subtitle' }, { children: "\u662F\u975E\u3001\u3053\u306E\u4FA1\u5024\u3092\u4F53\u9A13\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002" })), _jsx(ProffitSearchLandingPageCtaButton, { className: 'footer_button', isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal, trialText: 'まずは無料で使ってみる' })] })) })));
};
ProffitSearchLandingPageFooter.propTypes = {
    isEndTrial: propBool().isRequired,
    plan: propStr(),
    showFormModal: propFunc().isRequired,
};
ProffitSearchLandingPageFooter.defaultProps = {
    plan: undefined,
};
export default ProffitSearchLandingPageFooter;
